import React, { useEffect, useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import styles from './PerinHealthAlert.module.css';

const IdleTimeoutAlert = ({ show }) => {
  const [countdown, setCountdown] = useState(30); 

  useEffect(() => {
    if (show) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000); 

      return () => clearInterval(timer);
    } else {
      setCountdown(30);
    }
  }, [show]);

  return (
    <div className={styles.AlertContainer}>
      <Alert variant={'warning'}
        show={show}
        style={{ padding: "5px 5px" }}
        className={`${styles.Alert} ${styles.warningAlert}`}
      >
        <Alert.Heading className={styles.AlertHeading}>
          <div style={{ display: "flex", columnGap: "8px" }}>
            Session Expiring Soon
          </div>
        </Alert.Heading>
        <p className={styles.AlertBody}>
          {`You will be logged out in ${countdown % 60} seconds due to inactivity.`}
        </p>
      </Alert>
    </div>
  );
};

export default IdleTimeoutAlert;
